// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import store from './vuex-store';

Vue.config.productionTip = false;

// 全局配置
import api from './configs/apiConfig';
import config from './configs/config';
import http from './utils/httpUtils.js';
import utils from './utils/utils';
import service from './utils/service';
import aesUtil from './utils/aesUtil';
Vue.prototype.$A = api;
Vue.prototype.$H = http;
Vue.prototype.$C = config;
Vue.prototype.$U = utils;
Vue.prototype.$S = service;
Vue.prototype.$AES = aesUtil;


import aesUtils from './utils/aesUtil';
Vue.prototype.$AES = aesUtils;

import {
    routers
} from './router';

// 路由配置
Vue.use(VueRouter);
const RouterConfig = {
    mode: 'history', // 去除路由中的# 
    routes: routers
};

const router = new VueRouter(RouterConfig);

// 路由前置操作
router.beforeEach((to, from, next) => {
    next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>',
    methods: {
    },
    mounted() {
    },
    watch: {
    },
})



// WEBPACK FOOTER //
// ./src/main.js